import React, { Component } from "react";
import { AuthTopNav } from "../containers/TopNav";
import MyCirclesSection from '../containers/MyCirclesSection';
import Footer from "../containers/Footer";
import MobileNavbar from "../containers/MobileNavbar";

class Dashboard extends Component {
  render() {
    return (
      <div className="app-wrapper has-mobile-navbar">
        <AuthTopNav />
        <section className="gray-bg">
          <div className="main-container">
              <MyCirclesSection />
          </div>
        </section>         
        <MobileNavbar />
        <Footer />
      </div>
    );
  }
}

export default Dashboard;
